import type { GraphQLTypes, InputType } from '@zeus/index'
import { $, Selector } from '@zeus/index'
import { typedGql } from '@zeus/typedDocumentNode'
import { scalars } from '~/gql/utils/scalars'

const usersSelector = Selector('Users')({
  email: true,
  id: true,
  updatedAt: true,
  firstName: true,
  lastName: true,
  status: true,
  role: {
    name: true,
    id: true,
  },
  // Renseigné par `getFilteredUsers` seul (cf. Users.groups côté API) : les
  // autres requêtes le renvoient à null.
  groups: {
    id: true,
    name: true,
  },
  // Idem : agrégé par `getFilteredUsers` seul (cf. Users.progress côté API).
  progress: true,
})

const usersPaginationSelector = Selector('UserPagination')({
  users: usersSelector,
  total: true,
})

export const GQL_ADD_USER = typedGql('mutation')({
  createUser: [
    {
      createUserInput: $('createUserInput', 'CreateUserInput!'),
    },
    usersSelector,
  ],
})

export const GQL_IMPORT_USERS = typedGql('mutation')({
  importUsers: [
    { users: $('users', '[ImportUserInput!]!') },
    {
      createdCount: true,
      errorCount: true,
      errors: { line: true, email: true, reason: true },
    },
  ],
})

/**
 * Pré-vérification de l'import (#132) : parmi les adresses du fichier, celles
 * déjà rattachées à un compte de l'organisation. Lecture pure, jouée dès la
 * sélection du fichier pour annoncer les refus avant l'envoi.
 */
export const GQL_EXISTING_USER_EMAILS = typedGql('query')({
  getExistingUserEmails: [{ emails: $('emails', '[String!]!') }, true],
})

export const GQL_UPDATE_USER = typedGql('mutation')({
  updateUser: [
    { updateUserInput: $('updateUserInput', 'UpdateUserInput!') },
    usersSelector,
  ],
})

export const GQL_DELETE_USER = typedGql('mutation')({
  deleteUser: [
    {
      id: $('id', 'String!'),
    },
    true,
  ],
})

export const GQL_USER = typedGql('query', { scalars })({
  getUser: [{ id: $('id', 'Int!') }, usersSelector],
})

export const GQL_USERS_WITH_FILTERS = typedGql('query', { scalars })({
  getFilteredUsers: [
    {
      findManyUserWithFiltersInput: $('input', 'FindManyUserWithFiltersInput!'),
    },
    usersPaginationSelector,
  ],
})

export const GQL_USERS = typedGql('query', { scalars })({
  getUsers: {
    ...usersSelector,
  },
})

export type StoredUsers = InputType<
  GraphQLTypes['Users'],
  typeof usersSelector,
typeof scalars
>
